export const createTask = (title, value, filterCondition = true) => ({
  title,
  value,
  filterCondition,
});

export const filterSign = mode =>
  [
    'RULE_FIVE_SUM',
    'RULE_TEN_SUM',
    'RULE_FIVE_AND_TEN_SUM',
    'NO_MODE',
    'DECIMAL_MODE',
  ].includes(mode);
